import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { BiofixModal } from './BiofixModal'

type TBiofixModalTarget = { insectId: number; propertyId: number }

export const BiofixModalHost: FC = () => {
  const openedFor = detailsPanelStore.useSelector((s) => s.biofixModalOpenedForInsect)
  const [lastOpenedFor, setLastOpenedFor] = useState<TBiofixModalTarget | null>(null)

  useEffect(() => {
    if (openedFor) setLastOpenedFor(openedFor)
  }, [openedFor])

  const target = openedFor ?? lastOpenedFor

  if (!target) return null

  return <BiofixModal insectId={target.insectId} propertyId={target.propertyId} />
}
